import type { NavigationMenu } from '@/types/navigation'

export const buildB2bMenu = (): NavigationMenu => []
